import { apiPigeonMutator } from '../../config/pigeonMutator';
import {
	NotificationPriority,
	NotificationsResponse,
	NotificationsDetailResponse,
} from '~/libs/infrastructure/schemas';

export function getNotifications(type: string, paginationPage: Number, perPage: Number) {
	const fetchData = async () => {
		const data = await apiPigeonMutator<NotificationsResponse>({
			url: '/notifications',
			method: 'get',
			params: {
				'filter-security-sensitive': 'remove',
				'filter-priority': type == NotificationPriority.HIGH ? NotificationPriority.HIGH : null,
				page: paginationPage,
				perPage: perPage,
			},
		});
		return data;
	};
	return fetchData();
}

export function getNotificationsDetail(notificationId: string, notificationEmailId: string) {
	const fetchData = async () => {
		const data = await apiPigeonMutator<NotificationsDetailResponse>({
			url: `/notifications/${notificationId}/emails/${notificationEmailId}/body/html`,
			method: 'get',
		});
		return data;
	};
	return fetchData();
}

export function setNotificationRead(ids: string[]) {
	const fetchData = async () => {
		const data = await apiPigeonMutator({
			url: '/notifications/read',
			method: 'put',
			data: {
				notificationIds: ids,
			},
		});
		return data;
	};
	return fetchData();
}

export function setNotificationPriority(ids: string[], type: string) {
	const fetchData = async () => {
		const data = await apiPigeonMutator({
			url: '/notifications/priority',
			method: 'put',
			data: {
				notificationIds: ids,
				priority: type,
			},
		});
		return data;
	};
	return fetchData();
}
